<template>
  <div class="adjust-page">
    <div class="content">
      <!-- 商品基本信息 -->
      <van-card
        :desc="formatDesc(productInfo)"
        :price="formatePrice(productInfo)"
        :title="productInfo.productName"
        :thumb="'https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg'"
      >
        <template #price>
          <div class="flex flex-between">
            <span class="price">{{ formatePrice(productInfo) }}</span>
            <span v-if="productInfo.isWeigh" class="weight-badge">称</span>
          </div>
        </template>
        <template #footer>
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">系统库存:</span>
              <span class="info-value">{{ productInfo.stockNum }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">当前盘点数:</span>
              <span class="info-value">{{
                productInfo.currentInventoryNum
              }}</span>
            </div>
          </div>
        </template>
      </van-card>

      <!-- 调整表单 -->
      <van-form @submit="handleConfirm">
        <div class="form-wrapper">
          <div class="form-item">
            <van-field
              v-model="form.adjustNum"
              type="number"
              label="盘点数增加"
              :rules="[
                { required: true, message: '请输入调整数量（负数表示减少）' },
              ]"
              @input="handleInput"
            />
          </div>
        </div>

        <div class="button-wrapper">
          <van-button block type="default" @click="handleCancel"
            >取消</van-button
          >
          <van-button block type="primary" native-type="submit"
            >确认</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "InventoryAdjust",
  data() {
    return {
      form: {
        adjustNum: "",
      },
      productInfo: {
        planId: null,
        productId: null,
        productName: "",
        productCode: "",
        stockNum: 0,
        currentInventoryNum: 0,
        isWeigh: false,
        retailPrice: 0,
        unit: "",
      },

      planData: null,
    };
  },
  mounted() {
    const planId = this.$route.query.planId ? this.$route.query.planId : null;
    const productId = this.$route.query.productId
      ? this.$route.query.productId
      : null;

    const cacheKey = `inventory_plan_${planId}`;
    const cacheData = localStorage.getItem(cacheKey);
    try {
      const plan = JSON.parse(cacheData);

      this.planData = plan;

      const product = (plan.allProducts || []).find(
        (item) => (item.productId || item.id) === productId
      );
      if (!product) {
        this.$toast.fail("商品不存在");
        this.$router.go(-1);
        return;
      }
      this.productInfo = {
        ...product,
        planId,
        productId,
        productName: product.productName || product.name || "",
        productCode: product.productCode || product.code || "",
        stockNum: product.stockNum || 0,
        currentInventoryNum:
          product.inventoryNum === 0 || product.inventoryNum
            ? product.inventoryNum
            : "",
        isWeigh: product.isWeigh || product.isWeigh || false,
        retailPrice: product.retailPrice || 0,
        unit: product.unit || "",
      };
    } catch (e) {
      console.log(e);
      this.$toast.fail("缓存数据解析错误");
      this.$router.go(-1);
    }
  },
  methods: {
    handleInput(value) {
      let processed = value;

      if (!this.productInfo.isWeigh) {
        processed = processed.replace(/[^-\d]/g, "");

        if (processed.lastIndexOf("-") > 0) {
          processed = "-" + processed.replace(/-/g, "");
        }
      } else {
        processed = processed.replace(/[^-\d.]/g, "");

        if (processed.lastIndexOf("-") > 0) {
          processed = "-" + processed.replace(/-/g, "");
        }

        const dotIndex = processed.indexOf(".");
        if (dotIndex !== -1) {
          const intPart = processed.slice(0, dotIndex + 1);
          const decimalPart = processed.slice(dotIndex + 1).slice(0, 2);
          processed = intPart + decimalPart;
        }
      }

      if (processed !== value) {
        this.form.adjustNum = processed;
      }
    },

    handleCancel() {
      const { productId, ...queryObj } = this.$route.query;
      this.$router.replace({
        path: "/stock/inventory/goods",
        query: { ...queryObj },
      });
    },

    handleConfirm() {
      const adjustNum = parseFloat(this.form.adjustNum) || 0;

      const finalAdjustNum = this.productInfo.isWeigh
        ? adjustNum
        : Math.floor(adjustNum);

      const finalInventoryNum = this.$utils.preciseAdd(
        Number(this.productInfo.currentInventoryNum || 0),
        finalAdjustNum
      );
      try {
        const productIndex = (this.planData.allProducts || []).findIndex(
          (item) => (item.productId || item.id) === this.productInfo.productId
        );

        if (productIndex !== -1) {
          this.planData.allProducts[productIndex].inventoryNum =
            finalInventoryNum;
          const cacheKey = `inventory_plan_${this.productInfo.planId}`;
          localStorage.setItem(cacheKey, JSON.stringify(this.planData));
        } else {
          this.$toast.fail("商品不存在");
        }

        this.handleCancel();
      } catch (e) {
        this.$toast.fail("更新缓存失败");
        this.$router.go(-1);
      }
    },
    formatDesc(item) {
      return `商品条码：${item.externalCode || "--"}`;
    },
    formatePrice(item) {
      return "￥" + item.retailPrice + (item.unit ? `/${item.unit}` : "");
    },
  },
};
</script>

<style scoped>
::v-deep .van-card__price {
  width: 100%;
}
.adjust-page {
  min-height: 100vh;
  background: #f7f8fa;
}

.content {
  padding: 16px;
}

.product-title {
  display: inline-block;
  vertical-align: middle;
}

.weight-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-left: 6px;
  background: #ff6b00;
  color: #fff;
  font-size: 12px;
  border-radius: 50%;
  vertical-align: middle;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.info-item {
  flex: 1;
}

.info-label {
  color: #969799;
  font-size: 12px;
}

.info-value {
  color: #323233;
  font-size: 14px;
  margin-left: 4px;
}

.form-wrapper {
  margin-top: 16px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
}

.form-item {
  margin-bottom: 8px;
}

.adjust-hint {
  font-size: 12px;
  color: #999;
  padding-left: 10px;
}

.button-wrapper {
  margin-top: 32px;
  display: flex;
  gap: 16px;
  padding: 0 16px;
}

.button-wrapper .van-button {
  flex: 1;
}
</style>
